import React from "react";
import { MainContainer, InfoMainContainer, InfoContainer, ImageContainer, ImageStyled, LargeButton, CenterButton, StatusCode, Message1, Message2 } from "./styles";
import { Link } from 'react-router-dom';
import ErrorImage from "../../assets/hub-reserve-white.png";
import { ROUTES } from '../../routes/constants';
import { useNavigate } from 'react-router-dom';
import { ErrorPageProp } from "./types";

const ErrorPage: React.FC<ErrorPageProp> = ({
    isAdmin,
}) => {
    const navigate = useNavigate();

    return (
        <>
            <MainContainer>
                <InfoMainContainer>
                    <InfoContainer>
                        <StatusCode>404</StatusCode>
                        <Message1>¡Oh no! La página que buscas no se ha podido encontrar</Message1>
                        <Message2>Prueba regresando a la página inicial</Message2>
                    </InfoContainer>

                    <LargeButton onClick={() => {
                        if (isAdmin) {
                            navigate(`${ROUTES.ADMIN}${ROUTES.PANEL}`)
                        } else {
                            navigate(`${ROUTES.HOME}`)
                        }
                    }}
                    >Volver a Inicio</LargeButton>
                </InfoMainContainer>

                <ImageContainer>
                    <ImageStyled src={ErrorImage} alt="Motor Spot - Error icon"></ImageStyled>
                </ImageContainer>
            </MainContainer>
        </>
    );
}

export default ErrorPage;